// Internal libraries
import { appStore } from '@/store';
import { getCurrencyCodeAndValue } from './utils';

const mapCallbackShippingMethodsInput = methods => {
  const { form: formState } = appStore.getState();
  const { shippingInsuranceSelected } = formState;
  // Only pass in expected inputs or else the mutation would throw
  // received unexpected inputs errors
  return methods.map(method => {
    const {
      amount,
      hasInsurance: isInsuranceOffered,
      insuranceAmount,
      label,
      taxAmount,
      selected,
    } = method;
    const shouldUseInsuranceAmount =
      (!isInsuranceOffered && insuranceAmount) || shippingInsuranceSelected;
    return {
      default: method.default,
      label,
      selected,
      shippingAmount: getCurrencyCodeAndValue(amount),
      // prettier-ignore
      ...(shouldUseInsuranceAmount && {
        insuranceAmount: getCurrencyCodeAndValue(insuranceAmount),
      }),
      ...(taxAmount && { taxAmount: getCurrencyCodeAndValue(taxAmount) }),
    };
  });
};
export { mapCallbackShippingMethodsInput };
